import { createFileRoute } from '@tanstack/react-router'
import FaqPage from "../landing/FaqPage.tsx";

export const Route = createFileRoute('/faq')({
  component: RouteComponent,
})

function RouteComponent() {
  return <FaqPage />
}
